import React from 'react';
import config from "../../app/config";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./helpfulinfoVwq.module.scss");
  } else {
    styles = await import("./helpfulinfo.module.scss");
  }
})();

const Grid = ({ data, onInfoClick }) => {

  return (
    <div className={styles.gridContainer}>
      {data.map((item, index) => (
        <div className={styles.columnContainer}>
            <div className={styles.gridColumnHeader}>
            {item.displayTitle}
            </div>
            {item.componentsCollection.map((info) => {
                return (
                    <div className={styles.gridColumnItem}>
                        <button onClick={() => { onInfoClick(item, info) }} className={styles.gridColumnButton}>{info.displayTitle}</button>
                    </div>
                )
            })}
        </div>
      ))}
    </div>
  );
};

export default Grid;